'use client';

import { useEffect, useRef, useState } from 'react';

interface KlaviyoEmbedProps {
  html: string;
}

export function KlaviyoEmbed({ html }: KlaviyoEmbedProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [klaviyoReady, setKlaviyoReady] = useState(false);

  useEffect(() => {
    // Check if Klaviyo is already loaded
    if (typeof window !== 'undefined' && window._learnq) {
      setKlaviyoReady(true);
      return;
    }

    // Listen for Klaviyo ready event
    const handleKlaviyoReady = () => setKlaviyoReady(true);
    window.addEventListener('klaviyoReady', handleKlaviyoReady);

    return () => {
      window.removeEventListener('klaviyoReady', handleKlaviyoReady);
    };
  }, []);

  useEffect(() => {
    if (!containerRef.current || !klaviyoReady) return;

    // Set HTML content after Klaviyo is ready
    containerRef.current.innerHTML = html;
  }, [html, klaviyoReady]);

  return <div ref={containerRef} />;
}
